export const getAuthHeader = () => {
  const token =
    sessionStorage.getItem("token") ||
    sessionStorage.getItem("authToken") ||
    sessionStorage.getItem("accessToken");

  if (!token) return undefined;

  const normalized = String(token)
    .replace(/^"|"$/g, "")
    .replace(/^Bearer\s+/i, "")
    .trim();

  if (!normalized) return undefined;

  return `Bearer ${normalized}`;
};